import api from "../services/api";
import { APIS } from "../endpoints";

export const getAllNewslettersData = async (limit, page, searchTerm) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
        formData.append('search', searchTerm); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.newsletters}`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};
